import { Steps } from '../state/interfaces'

export const factorMap: Record<string, Record<string, Record<string, number>>> = {
  weight: {
    [Steps.STREAMING_VIDEO_QUALITY]: {
      no_streaming_video: 0,
      hd: 7,
      four_k: 25,
      streaming_i_dont_know: 0,
    },
    [Steps.ONLINE_GAMING]: {
      no_online_gaming: 0,
      casual_recreational: 3,
      seriously_competitive: 5,
      professional: 10,
      online_gaming_i_dont_know: 0,
    },
    [Steps.LARGE_FILES_DOWNLOAD_FREQUENCY]: {
      never: 0,
      rarely: 12,
      weekly: 25,
      daily: 50,
      large_files_i_dont_know: 0,
    },
    [Steps.ARE_YOU_MOVING]: {
      yes: 0,
      no: 0,
    },
  },
  factor: {
    [Steps.HOW_MANY_DEVICES]: {
      devices_1_3: 1,
      devices_4_7: 1.1,
      devices_8_10: 1.2,
      devices_11_more: 1.3,
      devices_0: 1,
      devices_i_dont_know: 1,
    },
    [Steps.HOW_MANY_PEOPLE_SIMULTANEOUSLY]: {
      people_1_2: 1.2,
      people_3_4: 2,
      people_4_more: 4,
    },
    [Steps.HOW_MANY_PEOPLE_WORKING_FROM_HOME]: {
      people_0: 1,
      people_1: 1.5,
      people_2: 2.4,
      people_3_more: 3,
    },
  },
  dataConsumption: {
    [Steps.STREAMING_VIDEO_QUALITY]: {
      no_streaming_video: 0,
      hd: 1700,
      four_k: 6800,
    },
    [Steps.ONLINE_GAMING]: {
      no_online_gaming: 0,
      casual_recreational: 300,
      seriously_competitive: 500,
      professional: 1000,
    },
    [Steps.LARGE_FILES_DOWNLOAD_FREQUENCY]: {
      never: 0,
      rarely: 5000,
      weekly: 10000,
      daily: 22500,
    },
  },
}
